export default {
  title: "Поддержка",
  instruction: "Инструкция по использованию личного кабинета",
  callcentreTitle: "Единый справочно-информационный центр АО «ЭКСПОЦЕНТР»",
  searchPlaceholder: "Поиск по вопросам",
  askQuestionBtn: "Задать свой вопрос",
  nothingFound: "Ничего не нашлось.",
  showMore: "Показать еще вопросы",
  howToTitle: 'Узнайте больше о AO "ЭКСПОЦЕНТР"'
};
